import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// Canonical host: any visit on a secondary domain lands on the same URL at .co.uk
const CANONICAL_HOST = "theperfectbreak.co.uk";
const { hostname, pathname, search, hash } = window.location;
if (hostname === "theperfectbreak.org" || hostname === "www.theperfectbreak.org") {
  window.location.replace(`https://${CANONICAL_HOST}${pathname}${search}${hash}`);
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
